export default "/assets/site/images/calendar.svg?5fe752f368699e6aead041e160ddbf87";